import { render, staticRenderFns } from "./InventoryUploadCSV.vue?vue&type=template&id=b2625de8&"
import script from "./InventoryUploadCSV.vue?vue&type=script&lang=ts&"
export * from "./InventoryUploadCSV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports